module.exports = __webpack_public_path__ + "static/assets/2cdfd14a17ab67ccda2e207b07d42672.png";